
import {useState, React, useEffect } from 'react'
import "./header.css"

export default function Header() {

  return (
    <div className='emas__home-header'>

        <div className='emas__home-header_container'>
            <h1>Electricity Market Modelling</h1>
            <p>Helping to clarify complex investment, market participation and design decisions</p>
        </div>
    </div>
  )
}
